import { CheckoutPageStdClient } from './CheckoutPageStdClient'

export type { CheckoutStdPageConfig } from './CheckoutPageStd'

export default CheckoutPageStdClient
